<template>
  <Dialog
    v-model:visible="visibleModel"
    header="Excluir Usuário do Sistema"
    :modal="true"
    class="w-full max-w-lg"
    :draggable="false"
  >
    <div class="flex flex-col gap-4 p-4">
      <p v-if="user">
        <strong>Atenção:</strong> Esta ação irá excluir permanentemente o usuário 
        <strong>{{ user.first_name }} {{ user.last_name }}</strong> ({{ user.email }}) do sistema.
      </p>
      
      <div v-if="user && user.accounts.length > 0" class="bg-yellow-50 border border-yellow-200 rounded p-4">
        <p class="text-yellow-800 font-semibold mb-2 flex items-center gap-2">
          <span class="material-icons text-yellow-600">warning</span>
          Vínculos Ativos
        </p>
        <p class="text-yellow-700 text-sm mb-2">Este usuário está conectado às seguintes contas:</p>
        <ul class="list-disc list-inside text-yellow-700 text-sm space-y-1">
          <li v-for="account in user.accounts" :key="account.id">{{ account.name }}</li>
        </ul>
        <p class="text-yellow-800 mt-3 text-sm font-medium">
          O usuário será removido de todas as contas automaticamente.
        </p>
      </div>
      
      <p class="text-red-600 font-semibold flex items-center gap-2">
        <span class="material-icons">error_outline</span>
        Esta ação não pode ser desfeita.
      </p>
    </div>
    
    <template #footer>
      <Button label="Cancelar" @click="visibleModel = false" class="p-button-text" />
      <Button 
        label="Excluir Usuário" 
        @click="$emit('confirm')" 
        severity="danger" 
        :loading="loading"
        :disabled="loading"
      />
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import type { SystemUser } from '@/types/user';
import { computed } from 'vue';

const props = defineProps<{
  visible: boolean;
  user: SystemUser | null;
  loading?: boolean;
}>();

const emit = defineEmits(['update:visible', 'confirm']);

const visibleModel = computed({
  get: () => props.visible,
  set: (val) => emit('update:visible', val)
});
</script>
